import { AuthProtectedLink, Button } from 'common/components';

import { useCustomer, useI18n } from 'common/hooks';
import { memo } from 'react';

import { routes } from 'routes/routes.constants';

type AuthButtonsProps = {
  collapsed?: boolean;
  className?: string;
  auth?: boolean;
};

const AuthButtons = (props: AuthButtonsProps) => {
  const { translate } = useI18n();
  const { isAuthenticated } = useCustomer();

  if (isAuthenticated) return null;

  return (
    <div className={props.className}>
      <a data-test='header-btn-register' className='' href={routes.getRegisterPage()}>
        <Button
          className={props.collapsed ? 'px-16' : ''}
          medium={!props.collapsed && !props.auth}
          small={props.collapsed}
          fit={props.collapsed}
          stretch={props.auth}
          large={props.auth}
        >
          {translate('mobile:header:register:btn-register')}
        </Button>
      </a>
      <AuthProtectedLink data-test='header-btn-login' className='' to={routes.getLoginPage()}>
        <Button
          className={props.collapsed ? 'px-16' : ''}
          medium={!props.collapsed}
          small={props.collapsed}
          fit={props.collapsed}
          outline={props.collapsed || props.auth}
          stretch={props.auth}
          large={props.auth}
          color='white'
        >
          {translate('mobile:header:register:btn-login')}
        </Button>
      </AuthProtectedLink>
    </div>
  );
};

export default memo(AuthButtons);
